export enum Controles {
  VACACIONES_VISUALIZAR_EMPLEADOS_COMPLETOS = 672,
  PERMISOS_REGISTRO_MULTIPLE = 791,
  PERSONAL_SINDICALIZADO_AOP = 795,
  RESUMEN_TIEMPO_X_TIEMPO = 800,

  TIPO_DE_CAMBIO_BOTON = 604,
  TIPO_DE_CAMBIO_ALTA = 602,
  TIPO_DE_CAMBIO_ELIMINAR = 603,

  ARRENDAMIENTO_MENU = 730,
  PATRIMONIOS_MENU = 605,
  PATRIMONIOS_VISUALIZAR_PATRIMONIO = 621,
  PATRIMONIOS_AGREGAR_PATRIMONIO = 606,
  PATRIMONIOS_EDITAR_PATRIMONIO = 607,
  PATRIMONIOS_DOCUMENTOS_PATRIMONIO = 622,
  PATRIMONIOS_AGREGAR_DOCUMENTO_PATRIMONIO = 608,
  PATRIMONIOS_ELIMINAR_DOCUMENTO_PATRIMONIO = 609,
  PATRIMONIOS_VISUALIZAR_DOCUMENTO_PATRIMONIO = 610,

  PATRIMONIOS_INMUEBLES = 623,
  PATRIMONIOS_VISUALIZAR_INMUEBLES = 611,
  PATRIMONIOS_AGREGAR_INMUEBLE = 612,
  PATRIMONIOS_EDITAR_INMUEBLE = 613,
  PATRIMONIOS_DOCUMENTOS_INMUEBLES = 624,
  PATRIMONIOS_AGREGAR_DOCUMENTO_INMUEBLE = 614,
  PATRIMONIOS_ELIMINAR_DOCUMENTO_INMUEBLE = 615,
  PATRIMONIOS_VISUALIZAR_DOCUMENTO_INMUEBLE = 616,
  PATRIMONIOS_VISUALIZAR_RELACION_PROPIETARIOS = 618,
  PATRIMONIOS_AGREGAR_RELACION_PROPIETARIOS = 619,
  PATRIMONIOS_ELIMINAR_RELACION_PROPIETARIOS = 620,
  PATRIMONIOS_AGREGAR_RELACION_CLIENTES = 626,

  REPORTE_PLD_MENU = 731,

  ACUSES_PLD_MENU = 833,
  ACUSES_AGREGAR_ACUSE = 834,
  ACUSES_EDITAR_ACUSE = 835,
  ACUSES_ELIMINAR_DOCUMENTOS = 836,
  ACUSES_AGREGAR_DOCUMENTOS = 837,

  PATRIMONIOS_CONDICIONES_CONTRATOS = 813,
  PATRIMONIOS_AGREGAR_CONDICIONES = 818,
  PATRIMONIOS_EDITAR_CONDICIONES = 814,
  PATRIMONIOS_CONTRATOS_PRORROGAS = 815,
  PATRIMONIOS_ARRENDADORES_EDITAR = 816,
  PATRIMONIOS_ARRENDADORES_DOCUMENTOS = 817,
  PATRIMONIOS_AGREGAR_CONTRATOS = 819,
  PATRIMONIOS_EDITAR_CONTRATOS = 820,
  PATRIMONIOS_DOCUMENTOS_CONTRATOS_ELIMINAR = 831,
  PATRIMONIOS_CONVENIOS = 822,
  PATRIMONIOS_AGREGAR_CONVENIO = 825,
  PATRIMONIOS_EDITAR_CONVENIO = 826,
  PATRIMONIOS_DOCUMENTOS_CONVENIO = 827,
  PATRIMONIOS_DOCUMENTOS_CONVENIO_ELIMINAR = 828,
  PATRIMONIOS_CONDICIONES_FACTURACION = 823,
  PATRIMONIOS_AGREGAR_CONDICIONES_FACTURACION = 829,
  PATRIMONIOS_EDITAR_CONDICIONES_FACTURACION = 830,
  PATRIMONIOS_CONTRATOS_DOCUMENTOS = 824,


  CLIENTES_MENU = 644,
  CLIENTES_AGREGAR_CLIENTE = 637,
  CLIENTES_EDITAR_CLIENTE = 638,
  CLIENTES_VISUALIZAR_CLIENTE = 639,
  CLIENTES_DOMICILIOS = 640,
  CLIENTES_CONTACTOS = 641,
  CLIENTES_DOCUMENTOS = 642,
  CLIENTES_DOCUMENTOS_AGREGAR_DOCUMENTO = 654,
  CLIENTES_DOCUMENTOS_ELIMINAR_DOCUMENTO = 655,
  CLIENTES_DOCUMENTOS_VISUALIZAR_DOCUMENTO = 656,
  CLIENTES_CUENTAS = 643,
  INFORMACION_GENERAL = 801,
  INFORMACION_GENERAL_AGREGAR = 865,
  INFORMACION_GENERAL_EDITAR = 866,
  INFORMACION_GENERAL_DOCUMENTOS = 867,
  INFORMACION_GENERAL_ELIMINAR_DOCUMENTOS = 868,

  PROPIETARIOS_MENU = 653,
  PROPIETARIOS_AGREGAR_PROPIETARIO = 645,
  PROPIETARIOS_EDITAR_PROPIETARIO = 646,
  PROPIETARIOS_VISUALIZAR_PROPIETARIO = 647,
  PROPIETARIOS_DOMICILIOS = 648,
  PROPIETARIOS_CONTACTOS = 649,
  PROPIETARIOS_DOCUMENTOS = 650,
  PROPIETARIOS_CUENTAS = 651,
  PROPIETARIOS_RELACION_CLIENTE = 652,
  PROPIETARIOS_CUENTAS_CONTABILIDAD = 673,

  ADMINISTRACION_TERCEROS = 727,
  AGREGAR_TERCERO = 728,
  ELIMINAR_TERCERO = 729,
  CUENTAS_CONTABLES = 796,


  PREDIALES_MENU = 658,
  PREDIALES_AGREGAR_SOLICITUD = 909,
  PREDIALES_SOLICITUD = 905,
  PREDIALES_ENVIAR_COMPROBANTE = 906,
  PREDIALES_EDITAR_SOLICITUD = 907,
  PREDIALES_DOCUMENTOS = 908,
  PREDIALES_ELIMINAR_DOCUMENTO = 910,

  CXC_MENU = 659,
  ESTADO_CUENTA_CXC_MENU = 660,
  REPORTE_TIMBRADO_CXC_MENU = 716,
  PAGOS_MENU = 628,
  PAGOS_AGREGAR_PAGO = 630,
  PAGOS_VISUALIZAR_PAGO = 631,
  PAGOS_ENVIAR_PAGO = 632,
  GRAFICOS_CXC = 798,
  ANTIGUEDAD_SALDOS_CXC_MENU = 857,
  PAGOS_CANCELAR_CFDI = 911,
  PAGOS_EDITAR_PAGO = 912,

  FACTURACION_MENU = 636,
  FACTURACION_AGREGAR_FACTURA = 633,
  FACTURACION_EDITAR_FACTURA = 657,
  FACTURACION_VISUALIZAR_FACTURA = 634,
  FACTURACION_ENVIAR_FACTURA = 635,
  CANCELAR_CFDI = 717,
  EJECUTAR_CANCELADO_CFDI = 894,

  LEGAL_MENU = 667,

  SEGUROS_MENU = 662,
  SEGUROS_AGREGAR_EDITAR_POLIZA = 664,
  SEGUROS_ELIMINAR_DOCUMENTOS_POLIZA = 665,
  SEGUROS_AGREGAR_DOCUMENTO_POLIZA = 666,
  SEGUROS_PAGOS_POLIZAS = 848,
  SEGUROS_ELIMINAR_DOCUMENTOS_PAGOS = 850,
  SEGUROS_AGREGAR_DOCUMENTO_PAGOS = 849,

  LICENCIAS_MENU = 668,

  CXP_MENU = 670,

  PROVEEDORES_MENU = 678,
  PROVEEDORES_AGREGAR_PROVEEDOR = 683,
  PROVEEDORES_EDITAR_PROVEEDOR = 684,
  PROVEEDORES_VISUALIZAR_PROVEEDOR = 685,
  PROVEEDORES_CUENTAS_BANCARIAS = 686,
  PROVEEDORES_AGREGAR_CUENTA_BANCARIA = 688,
  PROVEEDORES_EDITAR_CUENTA_BANCARIA = 689,
  PROVEEDORES_CONTACTOS = 687,
  PROVEEDORES_AGREGAR_CONTACTO = 690,
  PROVEEDORES_EDITAR_CONTACTO = 691,
  PROVEEDORES_CUENTAS_CONTABLES = 797,

  REQUISICIONES_MENU = 679,

  CXP_FACTURACION_MENU = 680,
  CXP_FACTURACION_CARGAR_FACTURAS = 693,
  CXP_FACTURACION_REVISAR_FACTURAS = 694,

  CXP_PAGOS_MENU = 681,
  CXP_PAGOS_AGREGAR_PAGO = 696,
  CXP_PAGOS_EDITAR_PAGO = 697,
  CXP_PAGOS_VISUALIZAR_PAGO = 698,
  CXP_PAGOS_DOCUMENTACION = 699,
  CXP_PAGOS_SOLICITUD_TRANSFERENCIA = 700,
  CXP_PAGOS_APLICACION_PAGO = 701,
  CXP_PAGOS_ENVIAR_PAGO = 774,
  CXP_PAGOS_CANCELAR_PAGO = 775,
  CXP_PAGOS_FUSIONAR_PAGOS = 790,
  GRAFICOS_CXP = 799,

  CONTABILIDAD_INTERFAZ_CONTPAQI = 702,

  COMPROBACION_GASTOS = 806,
  COMPROBACION_AUTORIZAR_SOLICITUD = 811,
  COMPROBACION_MARCAR_PAGADA_SOLICITUD = 812,

  UTILERIA_MENU = 900,
  UTILERIA_ADMINISTRACION = 898,
  UTILERIA_SEGURIDAD = 899,
  UTILERIA_LOG_LOGIN = 902,

  ASISTENTE_IA = 844

}
